module.exports = __webpack_public_path__ + "img/12.4c7b7cee.png";